// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <h1>Thank you for contacting us.</h1>
      <p>You will receive an automated email confirmation containing the text of your support request. A human response with next steps will follow within one business day. If an answer is not readily available or your issue needs to be escalated to an engineering resource, we will provide an estimated time to resolution.</p>
    </div>
  );
};

export default MarkdownComponent;
